<template>
  <div class="list-table-sort" :style="{ display: display }">
    <div class="sort" @click="onClickSort(sortName)">
      {{ name }}
      <template v-if="sort">
        <span class="sort__btn sort--asc" :class="{ 'is-active': search.sort === `+${sortName}` }">▲</span>
        <span class="sort__btn sort--desc" :class="{ 'is-active': search.sort === `-${sortName}` }">▼</span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    name: {
      type: String,
      default: '',
    },
    sortName: {
      type: String,
      default: '',
    },
    sort: {
      type: Boolean,
      default: true,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
    display() {
      return this.inline ? 'inline-block' : 'block'
    },
  },
  methods: {
    onClickSort(sort) {
      if (sort === '') return false
      let sortWord = this.search.sort
      let activeSort = ''
      if (sortWord.indexOf(sort) != -1) {
        let symbol = sortWord.substring(0, 1)
        let activeSymbol = symbol === '+' ? '-' : '+'
        activeSort = activeSymbol + sort
      } else {
        activeSort = '+' + sort
      }
      this.search.sort = activeSort

      this.$emit('search')
    },
  },
}
</script>

<style lang="scss" scoped>
.list-table-sort {
  .sort {
    position: relative;
    display: inline-block;
    padding-right: 3px;
    color: #515a6e;
    cursor: pointer;
    &__btn {
      position: absolute;
      font-size: 10px;
      opacity: 0.2;
      cursor: pointer;

      &:hover {
        opacity: 0.2;
      }
      &.is-active {
        opacity: 1;
      }
    }

    &--asc {
      top: -5px;
      right: -8px;
    }

    &--desc {
      bottom: -5px;
      right: -8px;
    }
  }
}
</style>
